import { api } from "./api"

export const GET_ALL_DEVICES = async (params: any = null) => {
    const {data} = await api.get(`/devices/all`, { params })
    return data;
}

export const GET_ALL_DEVICE_MODELS = async () => {
    const {data} = await api.get(`/devices/models`)
    return data;
}

export const GET_DEVICE_HISTORY = async (deviceId, start, finish) => {
    const {data} = await api.get(`/devices/${deviceId}/history/${start}/${finish}`)
    return data;
}

export const GET_DEVICE_HISTORY_LOGS = async (deviceId, start, finish) => {
    const {data} = await api.get(`/devices/${deviceId}/history/${start}/${finish}`, {
        responseType: 'text',
    })
    return data;
}

export const DELETE_DEVICE = async (deviceId) => {
    const {data} = await api.delete(`/devices/${deviceId}`)
    return data;
}

export const SAVE_DEVICE = async (params) => {
    const {data} = await api.post(`/devices/save`, params)
    return data;
}

export const TRIGGER_DEVICE_COMMAND = async (deviceId, key) => {
    const {data} = await api.post(`/devices/${deviceId}/command/${key}`)
    return data;
}

export const TRANSFER_DEVICES = async (params) => {
    const {data} = await api.post(`/devices/transfer`, params)
    return data;
}

export const GET_COMMANDS = async () => {
    const {data} = await api.get(`/devices/commands/all`)
    return data;
}
